import React from "react";
import { Card, Button, Col } from "react-bootstrap";

const InsightCard = ({ insight, handleEdit, handleDelete }) => {
  return (
    <Col md={6} lg={4}>
      <Card className="shadow-sm h-100">
        <div style={{ overflow: "hidden", height: "200px" }}>
          <Card.Img
            variant="top"
            src={insight.insight_image}
            alt={insight.title}
            style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.3s" }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
        </div>
        <Card.Body>
          <Card.Title className="fw-bold">{insight.title}</Card.Title>
          <Card.Text className="text-muted small mb-2">Category: {insight.category}</Card.Text>
          <Card.Text style={{ fontSize: "0.9rem" }}>{insight.brief_paragraph?.slice(0, 100)}...</Card.Text>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <small className="text-secondary">{new Date(insight.published_date).toLocaleDateString()}</small>
            <div>
              <Button variant="warning" size="sm" className="me-2" onClick={() => handleEdit(insight)}>Edit</Button>
              <Button variant="danger" size="sm" onClick={() => handleDelete(insight.insight_id)}>Delete</Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default InsightCard;
